const envConfig =
  process.env.APP_ENV === "production"
    ? {
        accountDomain: "account.pga.org",
        authDomain: "auth0.pga.com",
        adaptiveIcon: "./assets/adaptive-icon.png",
        androidIcon: "./assets/android-icon.png",
        androidPackage: "com.pga.pgamember",
        bundleIdentifier: "com.pga.PGAMember.production",
        googleServicesFile: "./google-services-prod.json",
        googleServicesPlist: "./GoogleService-Info-prod.plist",
        icon: "./assets/icon.png",
        intercom: {
          iosApiKey: "ios_sdk-d0a991608e661464a00d975efb63687fc8b5adac",
          androidApiKey: "android_sdk-db8c24aa112ae786258d4b2927ef304a8b543d4d",
          appId: "jyi16dpc",
        },
        jobsDomain: "jobs.pga.org",
        name: "PGA Member",
        runtimePolicy: "appVersion",
        scheme: "pgamember",
        webDomain: "my.pga.com",
      }
    : {
        accountDomain: "account.sandboxpga.org",
        authDomain: "auth0.dev.pga.com",
        adaptiveIcon: "./assets/adaptive-icon-dev.png",
        androidIcon: "./assets/android-icon-dev.png",
        androidPackage: "com.pga.pgamember.staging",
        bundleIdentifier: "com.pga.PGAMember.staging",
        googleServicesFile: "./google-services-dev.json",
        googleServicesPlist: "./GoogleService-Info-dev.plist",
        icon: "./assets/icon-dev.png",
        intercom: {
          iosApiKey: "ios_sdk-6303f2e622dacdc4b68798fd6004457d0b3b21fc",
          androidApiKey: "android_sdk-15debd552ff3712d36d29f9ac0de24df5f229368",
          appId: "c722leqk",
        },
        jobsDomain: "jobs.sandboxpga.org",
        name: "PGA Member (Dev)",
        runtimePolicy: "sdkVersion",
        scheme: "pgamemberdev",
        webDomain: "my.dev.pga.com",
      };
const projectId = "45a81e5c-45c9-4e66-a5ab-8ff840e2e88f";
const webDomain = process.env.WEB_DOMAIN;

const splash = {
  image: "./assets/splash.png",
  resizeMode: "contain",
  backgroundColor: "#00234B",
};

module.exports = {
  name: envConfig.name,
  slug: "membership-mobile-app",
  scheme: envConfig.scheme,
  owner: "pgahq",
  version: "1.4.0",
  orientation: "portrait",
  icon: envConfig.icon,
  userInterfaceStyle: "light",
  splash,
  updates: {
    fallbackToCacheTimeout: 0,
    url: `https://u.expo.dev/${projectId}`,
    checkAutomatically: "ON_ERROR_RECOVERY",
  },
  assetBundlePatterns: ["**/*"],
  ios: {
    supportsTablet: true,
    splash: {
      ...splash,
      tabletImage: "./assets/splash-tablet.png",
    },
    bundleIdentifier: envConfig.bundleIdentifier,
    googleServicesFile: envConfig.googleServicesPlist,
    config: {
      usesNonExemptEncryption: false,
    },
    infoPlist: {
      NSCameraUsageDescription: "Scan cards to pay dues.",
      NSPhotoLibraryUsageDescription: "Send photos to membership services.",
    },
    associatedDomains: [
      `applinks:${webDomain}`,
      `applinks:${envConfig.jobsDomain}`,
      `applinks:${envConfig.accountDomain}`,
      `webcredentials:${envConfig.authDomain}`,
    ],
  },
  android: {
    package: envConfig.androidPackage,
    googleServicesFile: envConfig.googleServicesFile,
    icon: envConfig.androidIcon,
    adaptiveIcon: {
      foregroundImage: envConfig.adaptiveicon,
      backgroundColor: "#003067",
    },
    intentFilters: [
      { host: webDomain, pathPrefix: "/member" },
      { host: envConfig.jobsDomain, pathPrefix: "/recommended" },
      { host: envConfig.jobsDomain, pathPrefix: "/detail" },
      { host: envConfig.accountDomain, pathPrefix: "/job-preferences" },
    ].map(({ host, pathPrefix }) => ({
      action: "VIEW",
      autoVerify: true,
      data: [{ scheme: "https", host, pathPrefix }],
      category: ["BROWSABLE", "DEFAULT"],
    })),
  },
  web: {
    favicon: "./assets/favicon.png",
  },
  extra: {
    webDomain,
    jobsDomain: envConfig.jobsDomain,
    accountDomain: envConfig.accountDomain,
    eas: {
      projectId,
    },
  },
  runtimeVersion: {
    policy: envConfig.runtimePolicy,
  },
  plugins: [
    [
      "expo-build-properties",
      {
        ios: { useFrameworks: "static" },
        android: { compileSdkVersion: 34, targetSdkVersion: 34 },
      },
    ],
    "expo-font",
    "expo-secure-store",
    "@react-native-firebase/app",
    ["@intercom/intercom-react-native", envConfig.intercom],
    ["./expo-raygun-plugin.js"],
    ["./expo-disable-firebase-ad-id-plugin.js"],
    ["expo-location"],
    [
      "@stripe/stripe-react-native",
      {
        merchantIdentifier: `merchant.com.${envConfig.scheme}`,
        enableGooglePay: true,
      },
    ],
    [
      "react-native-auth0",
      {
        domain: envConfig.authDomain,
        customScheme: envConfig.customScheme,
      },
    ],
  ],
};
